/**
 *  Game play status
 */
export enum GamePlayStatus {
  //**NotStarted/
  NotStarted = 0,
  //**InProgress/
  InProgress = 1,
  //**completed/
  Completed = 2,
}
